/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import { DeliveryOrderDetailFragmentDoc } from '../../../components/Bag/GraphQL/Cart.generated';
import { ValidationErrorFieldsFragmentDoc } from '../../../graphql/fragments/ValidationErrorFields.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrdersQueryVariables = Types.Exact<{
  input: Types.OrdersInput;
}>;

export type OrdersQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly description: string;
          readonly orderType: Types.OrderType;
          readonly total: number | null;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly quantity: number;
            readonly customName: string | null;
            readonly isCustom: boolean;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
            };
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly slug: string;
          };
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const ordersQueryMock: ExecutionResult<OrdersQuery> = {
  data: {
    orders: {
      __typename: 'OrdersResponseSuccess',
      orders: [
        {
          id: '509e6ea9-fee4-42a9-9625-87ce71904308',
          description: 'Hello World',
          orderType: 'DELIVERY',
          total: 65,
          asset: { url: 'Hello World' },
          lineItems: [
            {
              id: '7a7163ba-7eda-496e-8a18-5e3da00a9a47',
              quantity: -36,
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: '4319d080-60b5-49aa-a50f-9c4016b1bd63',
                name: 'Hello World',
                isCustom: false,
                categoryName: 'Hello World',
              },
            },
            {
              id: 'cb273b7f-9f18-4d03-8f1b-1f2c49f5fd79',
              quantity: 25,
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: 'ccdcab38-b748-45af-be88-532ede7a1daa',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
            {
              id: '33e0e095-a7b4-48f0-bb56-0d0180d39ca0',
              quantity: 62,
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: '520a352a-4a65-441b-9bc5-d089f52e921d',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
          ],
          restaurant: {
            id: '1bfdfbab-d38f-4df8-ab15-0587b384c482',
            name: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            address: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: true,
            slug: 'Hello World',
          },
          deliveryOrderDetail: {},
        },
        {
          id: '9be511f9-b1e3-49b6-974a-fbe52f8a3a6f',
          description: 'Hello World',
          orderType: 'DELIVERY',
          total: -59,
          asset: { url: 'Hello World' },
          lineItems: [
            {
              id: 'f0edaef1-2281-40af-a915-21b27f2badd9',
              quantity: 62,
              customName: 'Hello World',
              isCustom: true,
              product: {
                id: 'f96f010c-a153-4964-a978-8b394138d500',
                name: 'Hello World',
                isCustom: false,
                categoryName: 'Hello World',
              },
            },
          ],
          restaurant: {
            id: '934e080a-d7fd-4625-94dd-94f36b41c23d',
            name: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            address: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: false,
            slug: 'Hello World',
          },
          deliveryOrderDetail: {},
        },
        {
          id: 'c4b96caa-8622-4a51-bd3c-bc3f05167a35',
          description: 'Hello World',
          orderType: 'DELIVERY',
          total: 3,
          asset: { url: 'Hello World' },
          lineItems: [
            {
              id: '451b9313-663d-4b9e-b2f5-17f534a27f5a',
              quantity: 53,
              customName: 'Hello World',
              isCustom: true,
              product: {
                id: 'bda03bfa-f7e2-47a5-9a38-1e64855fe3c2',
                name: 'Hello World',
                isCustom: false,
                categoryName: 'Hello World',
              },
            },
            {
              id: '70d5f38a-ff27-4422-8629-33169f0cff6a',
              quantity: 23,
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: '47d88d8e-ee30-4f22-b944-d253ab94c401',
                name: 'Hello World',
                isCustom: false,
                categoryName: 'Hello World',
              },
            },
            {
              id: '07664c55-f9f5-4160-95e6-ededc961aaee',
              quantity: 58,
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: '6e40545d-8c25-44bf-a759-135291a95511',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
          ],
          restaurant: {
            id: 'bad1e171-218c-4ef4-b3e4-8fb0e31ab26e',
            name: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            address: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: true,
            slug: 'Hello World',
          },
          deliveryOrderDetail: {},
        },
      ],
    },
  },
};

export const OrdersDocument = gql`
  query orders($input: OrdersInput!) {
    orders(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          description
          orderType
          total
          asset {
            url
          }
          lineItems {
            id
            quantity
            customName
            isCustom
            product {
              id
              name
              isCustom
              categoryName
            }
          }
          restaurant {
            id
            name
            city
            state
            address
            zipCode
            isOutpost
            slug
          }
          deliveryOrderDetail {
            ...DeliveryOrderDetail
          }
        }
      }
      ...ValidationErrorFields
    }
  }
  ${DeliveryOrderDetailFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useOrdersQuery(
  options: Omit<Urql.UseQueryArgs<OrdersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrdersQuery, OrdersQueryVariables>({
    query: OrdersDocument,
    ...options,
  });
}
